export const CpaeLabelsEnum: any = {
  identification_document_file: 'Documento de identificação',
  location_plan_file: 'Planta de localização',
  situation_plan_file: 'Planta de situação',
  location_and_activity_analysis: 'Análise de localização e atividade',
};

export const CpaeNotRequiredInputNames = [`complement`];
